import { StatusChip } from "components/StatusChip";

import { DifferenceRow, differenceChipLabel } from "./differences";

/** The line's own value, chipped beside the rules' answer it contradicts. */
export function DifferenceChip({ row }: { row: DifferenceRow }) {
  return <StatusChip color="warning" size="small" label={differenceChipLabel(row)} />;
}
